export default __webpack_public_path__ + "static/media/English1.c1eed7bb.png";